import { useStoreData } from '../use-store-data';

export const useStoreSlug = (): string => {
  const storeState = useStoreData();
  return storeState?.storeSlug || '';
};
